<template>
  <div class="suggestion">
    <div class="is-flex gap-1 is-align-center title">
      <el-rate v-model="rate" disabled class="w-50" />
      <p> {{ review }}</p>
    </div>
    <p v-if="comments" class="pt-2">{{ comments }}</p>
    <el-tag :class="'small'" v-for="(tag, index) in tags" :key="index" class="mt-2">{{ formatText(tag) }}</el-tag>
  </div>
</template>

<script>
export default {
  name: "ReviewsTitle",
  props: {
    id: {
      type: [String, Number],
      default: "",
      required: true,
    },
    rate: {
      type: Number,
      default: 0,
      required: true,
    },
    tags: {
      type: Array,
      default() {
        return [];
      },
    },
    review: {
      type: String,
      default: "",
    },
    comments: {
      type: String,
      default: "",
    },
  },

};
</script>

<style lang="scss" scoped>
.suggestion {
  position: relative;

  .title {
    span {
      margin-left: 10px;
    }
  }
  a {
    color: var(--eden-green-primary);
    font-size: 0.825rem;
  }

  p {
    color: var(--eden-grey-secondary);
    width: 80%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 0.825rem;
  }

  .item {
    display: inline-block;
    margin-top: 8px;
    color: var(--eden-grey-primary);
    border: 1px solid var(--eden-grey-quaternary);
    border-radius: 8px;
    padding: 4px 8px;
    font-size: 0.75rem;
  }
}
</style>
